import React, { FC } from 'react';
import { Action, Icon, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';
import { LandscapeBuyerRelationType } from '../../../store/landscapeAPI/landscape/landscape-buyer-relation-type';

interface TableItem {
  id: string;
  logo: string;
  name: string;
  url: string;
  relationType: LandscapeBuyerRelationType;
}

interface LandscapeAboutCommittedBuyersOrganismProps {
  data: TableItem[];
  handleDelete: (id: string) => void;
}

const LandscapeAboutCommittedBuyersOrganism: FC<
  LandscapeAboutCommittedBuyersOrganismProps
> = ({ data, handleDelete }) => {
  return (
    <SortableTable
      data={data}
      showEditButtonHeader={false}
      columns={[
        { label: 'Logo', key: 'logo' },
        { label: 'Partners', key: 'name' },
        { label: 'Url', key: 'url' },
        { label: 'Relation', key: 'relationType' },
        { label: '' },
      ]}
      renderRow={(row) => (
        <TableRow>
          <Icon imageUrl={row.logo ?? ''} shape="thumbnail" size="s" />
          <Label content={row.name ?? ''} />
          <Label content={row.url ?? ''} />
          <Label content={row.relationType} />
          <Action
            type="delete"
            itemName={row.name}
            size="sm"
            onClick={() => handleDelete(row.id)}
          ></Action>
          <Label />
        </TableRow>
      )}
    />
  );
};

export default LandscapeAboutCommittedBuyersOrganism;
